export default "__VITE_ASSET__CP38bP$9__"